import { WordAudioButton } from "./WordAudioButton";
import { getEntriesByTopic } from "../../data/vocab/library";

/** The 10 super-zinnen — phrases that anchor every Deel answer. Rendered
 *  on the /woorden landing as a single ember-bordered panel above the
 *  topic grid. Plain list, no expand affordance — these are meant to be
 *  drilled to muscle memory, not browsed for grammar notes. */
export function SuperZinnenCard() {
  const entries = getEntriesByTopic("super-zinnen");

  return (
    <section className="rounded-2xl border border-[var(--border)] bg-[var(--panel)] p-5 sm:p-6 space-y-4">
      <header className="space-y-1.5">
        <p className="text-xs uppercase tracking-wider text-[var(--ink-faint)] font-mono-badge">
          10 Super-zinnen
        </p>
        <h2 className="text-xl sm:text-2xl font-semibold tracking-tight">
          De zinnen die elk antwoord winnen.
        </h2>
      </header>
      <ul className="space-y-2">
        {entries.map((e) => (
          <li
            key={e.id}
            className="flex items-start gap-3 py-2 border-b border-[var(--border)] last:border-b-0"
          >
            <div className="flex-1 min-w-0">
              <p className="font-serif-italic text-[var(--ink)] leading-snug">
                {e.dutch}
              </p>
              <p className="text-sm text-[var(--ink-muted)] leading-snug">
                {e.english}
              </p>
            </div>
            <WordAudioButton text={e.dutch} />
          </li>
        ))}
      </ul>
      <p className="text-xs uppercase tracking-wider text-[var(--ink-faint)] font-mono-badge pt-2">
        Tip: drill totdat ze in &lt;1 seconde uit uw mond rollen.
      </p>
    </section>
  );
}
